module.exports = __webpack_public_path__ + "static/media/1POLICY19.8b936720.jpg";